import { Controller } from "@hotwired/stimulus"
import { createApp } from "vue"

// Mounts a Vue SFC by name. Components live in app/frontend/components/*.vue and
// are bundled by Vite via the eager glob below. Props come from a JSON
// data-props attribute on the mount element.
const components = import.meta.glob("../components/*.vue", { eager: true })

export default class extends Controller {
  static values = { component: String }

  connect() {
    const mod = components[`../components/${this.componentValue}.vue`]
    if (!mod) {
      console.error(`Vue component not found: ${this.componentValue}`)
      return
    }
    const props = JSON.parse(this.element.dataset.props || "{}")
    this.app = createApp(mod.default, props)
    this.app.mount(this.element)
  }

  disconnect() {
    this.app?.unmount()
  }
}
